import clsx from "clsx";

const Sidebar = ({className, title = 'Section Order', options, activeSidebar, onChange}) => {
    return (
        <div className={clsx('flex flex-col bg-white border border-[#DDDDDD] max-h-[85vh] rounded-md', className)}>
            <div className={'font-bold text-blue-90 italic text-sm p-3 border-b border-[#DDDDDD]'}>
                {title}
            </div>
            <div className={'flex flex-col space-y-4 py-4 text-[#2B2B2B] rounded-b-md overflow-y-scroll'}>
                {
                    options?.map((item, index) =>
                        <div
                            key={index}
                            className={`flex font-bold capitalize text-[#2B2B2B] p-4 hover:bg-[#F2F7FF] border-l-8 cursor-pointer ${activeSidebar === item ? 'bg-[#F2F7FF] border-[#3C6CD6]' : 'border-white hover:border-[#F2F7FF]'}`}
                            onClick={() => onChange(item)}
                        >
                            {item}
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default Sidebar
